import {
    CREATE_NEW_SUPPLIER,
    DELETE_SUPPLIER,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    GET_SUPPLIER_DETAIL,
    GET_SUPPLIER_LIST,
    SHOW_MESSAGE,
    UPDATE_SUPPLIER_DETAIL,
} from '../ActionTypes'
import JwtAxios from "../../apiServices";
import {
    CREATE_COMPETITOR_ENDPOINT,
    DELETE_COMPETITOR_ENDPOINT,
    EDIT_COMPETITOR_ENDPOINT,
    GET_COMPETITOR_ENDPOINT
} from "../../apiServices/API_ENDPOINTS";
import HandleNotification from "../../common/Notification";

export const onGetSupplierList = (page, per_page, name) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .get(`${GET_COMPETITOR_ENDPOINT}`, {
                params: {
                    page: page,
                    per_page: per_page,
                    ...(name && { name: name }),
                },
            })
            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: GET_SUPPLIER_LIST, payload: data.data.data});
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

            });
    };
};

export const onGetSupplierDetails = (supplierId) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .get(`api/suppliers/${supplierId}/edit`)

            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: GET_SUPPLIER_DETAIL, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "Supplier Updated Successfully",
                    });
                    // HandleNotification('success', 'bottomRight', 'Supplier Account updated Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    // HandleNotification('success', 'bottomRight', 'Something went wrong!', null)
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

            });
    };
};

export const onCreateSupplier = (supplier) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .post(`${CREATE_COMPETITOR_ENDPOINT}`, supplier)
            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: CREATE_NEW_SUPPLIER, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "Supplier Created Successfully",
                    });
                    HandleNotification('success', 'bottomRight', 'supplier Created Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('success', 'bottomRight', 'Something went wrong!', null)

            });
    };
};
export const onUpdateSelectedSupplier = (supplier) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .put(`${EDIT_COMPETITOR_ENDPOINT}/${supplier.id}`, supplier)

            .then((data) => {
                if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: UPDATE_SUPPLIER_DETAIL, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "supplier Updated Successfully",
                    });
                    HandleNotification('success', 'bottomRight', 'supplier updated Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', 'Something went wrong!', null)
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
            });
    };
};
export const onDeleteSupplier = (supplier) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .delete(`${DELETE_COMPETITOR_ENDPOINT}/${supplier['id']}`)
            .then((data) => {
                if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: DELETE_SUPPLIER, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "Deleted supplier Successfully",
                    });

                    HandleNotification('success', 'bottomRight', 'supplier deleted Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', 'Something went wrong!', null)
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
            });
    };
};
